import { useRouter } from 'next/router'
import * as React from 'react'
import { SuccessPageHeader } from '../components/SuccessPage/SuccessPageHeader'
import { FAQSection } from '../components/FAQSection'
import * as changeCase from 'capital-case'
import Head from 'next/head'
import { always, ifElse } from 'ramda'
import Layout from '../components/Layout'
import { DiscountModal } from '../components/SuccessPage/DiscountModal'
// import { Contact } from '../generated/nest-graphql'
import { nestBackendClient } from '../components/clients/nest-backend.client'
import { HappinessGuaranteeSection } from '../components/HappinessGuaranteeSection'
import { Container } from '../components/Container'
import Image from 'next/image'

import shieldTickIcon from '../../public/img/icons/shield-tick-blue.svg'
import brakeIcon from '../../public/img/icons/brake-icon-black.png'
import receiptDiscountIcon from '../../public/img/icons/receipt-discount-icon-black.png'
import clockIcon from '../../public/img/icons/clock-icon-black.png'
import documentIcon from '../../public/img/icons/document-icon-black.png'
import likeShapedIcon from '../../public/img/icons/like-shaped-icon-black.png'
import shieldTickIconBlack from '../../public/img/icons/shield-tick-icon-black.png'

function getImageForMake(make?: string) {
  const makesWithImage = [
    'acura',
    'audi',
    'bmw',
    'buick',
    'cadillac',
    'chevrolet',
    'chrysler',
    'dodge',
    'fiat',
    'ford',
    'gmc',
    'honda',
    'hyundai',
    'infiniti',
    'jaguar',
    'jeep',
    'kia',
    'lexus',
    'maserati',
    'mazda',
    'mercedes',
    'mitsubishi',
    'nissan',
    'porsche',
    'ram',
    'saab',
    'subaru',
    'suzuki',
    'tesla',
    'toyota',
    'volkswagen',
    'volvo',
  ]
  return ifElse(
    (m) => makesWithImage.includes(m),
    (m) => `/img/${m}.png`,
    always('/img/nubrakes-van-house-800-num.jpg')
  )(make)
}

const generatePageTitle = (firstName, year, make, model) => {
  if (!year && !make && !model) return `Thank you, we've received your request!`
  return `Thank you${
    firstName ? ` ${firstName}` : ''
  }, We've received your quote request for your ${year} ${make} ${model}!`
}

const generateTestimonialText = (make) => {
  if (!make) return `Here's what other customers are saying about NuBrakes: `
  return `Here's What Other ${changeCase.capitalCase(make)} Customers Are Saying About NuBrakes:`
}

const SuccessPageTemplate: React.FC<{
  make: string
  year: string
  model: string
  firstName: string
  phoneNumber: string
}> = ({ make, model, firstName, year, phoneNumber }) => {
  const [modalIsOpen, setIsOpen] = React.useState(false)
  // const [contact, setContact] = React.useState<Contact>()
  // const [isLoading, setIsloading] = React.useState(true)
  const getData = async () => {
    try {
      if (!phoneNumber) return
      await nestBackendClient.get('/contacts/public/by-phone-number', {
        params: {
          phone: phoneNumber,
        },
      })
      // setContact(result.data)
    } catch (error) {}
    // setIsloading(false)
  }

  React.useEffect(() => {
    getData()
  }, [phoneNumber])

  React.useEffect(() => {
    if (phoneNumber) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }, [phoneNumber])

  function closeModal() {
    setIsOpen(false)
  }
  const image = getImageForMake(make)
  return (
    <>
      <SuccessPageHeader
        year={year}
        title={generatePageTitle(firstName, year, make, model)}
        make={make}
        image={image}
        othersSaying={generateTestimonialText(make)}
        model={model}
        firstName={firstName}
      />
      <DiscountModal onRequestClose={closeModal} isOpen={modalIsOpen} phoneNumber={phoneNumber} />
      <ReviewsSection />
      <IncludeInAllServicesSection />
      <FAQSection title={`Frequently Asked Questions`} description={``} />
      <HappinessGuaranteeSection
        backgroundColor="#FFF"
        title="HAPPINESS GUARANTEED"
        description={
          <p>
            Our brake techs have decades of combined experience, and all services are backed by our{' '}
            <strong className="text-[#f04f23]">NuBrakes Guarantee.</strong>
          </p>
        }
      />
    </>
  )
}

type SuccessQueryType = {
  vehicleYear?: string
  vehicleMake?: string
  vehicleModel?: string
  firstName?: string
  inquiry?: string
  phoneNumber?: string
}

declare global {
  interface Window {
    _conv_q: any
    convert?: {
      currentData: {
        experiments?: Record<
          string,
          {
            first_time?: boolean
            variation_id?: number
            variation_name?: string
          }
        >
        experiments_goals?: any
        goals?: any
      }
    }
  }
}

const SuccessPage: React.FC = () => {
  const router = useRouter()
  const {
    vehicleYear = '',
    vehicleMake = '',
    vehicleModel = '',
    firstName = '',
    phoneNumber = '',
  }: SuccessQueryType = router.query

  return (
    <Layout title={'Success! | NuBrakes Mobile Brake Repair'}>
      <Head>
        <script src="https://storyprompt.com/js/iframeResizer.min.js" defer></script>
        <script src="https://storyprompt.com/js/iframeResizer.min.js" async></script>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <SuccessPageTemplate
        make={vehicleMake}
        model={vehicleModel}
        firstName={firstName}
        year={vehicleYear}
        phoneNumber={phoneNumber}
      />
    </Layout>
  )
}

const ReviewsSection = () => {
  return (
    <Container className="h-full mt-5">
      <div className="flex flex-col items-center h-full">
        <h2 className="text-black text-2xl lg:text-4xl max-w-lg text-center">
          Trusted By 100,000+ Customers Just Like You
        </h2>
        <div className="flex items-center justify-center mb-4">
          <Image src={shieldTickIcon} height={30} width={30} alt="shield security icon" />
          <span className="text-sm capitalize">NuBrakes never offers incentives for reviews</span>
        </div>
        <iframe
          loading="eager"
          id="SP_cmFDSnceVq2r7aASVGuT"
          src="https://storyprompt.com/wall/iNyNnwLvMy5bxfSiRaTN"
          frameBorder="0" 
          width="100%"
          //height="100vh"
          height="600px"
        ></iframe>
      </div>
    </Container>
  )
}

const everyServices = [
  {
    icon: clockIcon,
    title: 'mobile service',
    description: 'Save 3+ hours',
  },
  {
    icon: documentIcon,
    title: 'Free inspection',
    description: 'Only Repairs You Need',
  },
  {
    icon: brakeIcon,
    title: 'Premium parts',
    description: 'Manufacturer Quality',
  },
  {
    icon: likeShapedIcon,
    title: 'Warranty guarantee',
    description: 'For Peace of Mind',
  },
  {
    icon: receiptDiscountIcon,
    title: 'Up front pricing',
    description: 'No Nasty Surprises',
  },
  {
    icon: shieldTickIconBlack,
    title: 'Expert techs',
    description: 'Decades of Experience',
  },
]
const IncludeInAllServicesSection = () => {
  return (
    <div className="bg-gray-50">
      <Container className=" text-center pt-7 flex flex-col">
        <h2 className="text-black text-2xl lg:text-4xl w-full">
          Included <br /> with every service
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 my-3 w-full">
          {everyServices.map((service, idx) => (
            <div className="border flex flex-col items-center h-full bg-white rounded-xl py-6 px-2 lg:px-4 w-full" key={idx}>
              <div>
                <Image width={61} height={61} src={service.icon} />
              </div>
              <h4 className="text-[#f04f23] text-sm lg:text-base m-0">{service.title}</h4>
              <p className="m-0 mt-auto text-sm">{service.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export const getServerSideProps = async function () {
  return { props: {} }
}

export default SuccessPage
